import * as React from "react";
const SvgFiRrTargetAudience = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-target-audience_svg__a)">
      <path
        fill="#062147"
        d="M7.058 4.962c.839 0 1.595.346 2.139.901a5 5 0 0 0-2.198 4.138c0 .328.036.647.097.958q-.019.002-.038.004a3 3 0 1 1 0-6.001M17 5c-.841 0-1.599.349-2.144.906A4.99 4.99 0 0 1 16.9 10.99c.034.001.066.01.1.01a3 3 0 1 0 0-6m-5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 2c-1.754 0-3.335 1.063-3.935 2.646a1 1 0 1 0 1.871.709c.307-.811 1.137-1.354 2.065-1.354s1.758.544 2.065 1.354a1 1 0 0 0 1.289.582c.516-.196.776-.773.581-1.29-.6-1.582-2.181-2.646-3.935-2.646zm3.7-1.803a1 1 0 1 0 .6 1.908Q16.636 15 17 15c.928 0 1.758.544 2.065 1.354a1 1 0 0 0 1.289.582c.516-.196.776-.773.581-1.29C20.335 14.064 18.754 13 17 13a4.3 4.3 0 0 0-1.3.197M7 13c-1.754 0-3.335 1.063-3.935 2.646a1 1 0 1 0 1.87.708C5.242 15.543 6.072 15 7 15q.365 0 .7.105a1 1 0 1 0 .6-1.908A4.3 4.3 0 0 0 7 13m0 9H5c-1.654 0-3-1.346-3-3v-2a1 1 0 1 0-2 0v2c0 2.757 2.243 5 5 5h2a1 1 0 1 0 0-2m16-6a1 1 0 0 0-1 1v2c0 1.654-1.346 3-3 3h-2a1 1 0 1 0 0 2h2c2.757 0 5-2.243 5-5v-2a1 1 0 0 0-1-1M19 0h-2a1 1 0 1 0 0 2h2c1.654 0 3 1.346 3 3v2a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5M1 8a1 1 0 0 0 1-1V5c0-1.654 1.346-3 3-3h2a1 1 0 1 0 0-2H5C2.243 0 0 2.243 0 5v2a1 1 0 0 0 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-target-audience_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTargetAudience;
